import { Box } from '@mui/material'
import Header from './Header'
import Footer from './Footer'

export default function Layout({ page, onNavigate, children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header page={page} onNavigate={onNavigate} />
      <Box component="main" sx={{ flex: 1, px: { xs: 2, md: 3 }, py: 3, maxWidth: 1400, mx: 'auto', width: '100%' }}>
        {children}
      </Box>
      <Footer />
    </Box>
  )
}
